import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import { Alert, Radio } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask } from '@fortawesome/pro-solid-svg-icons';

import { mapId, mapName } from 'helpers/react_select_helpers';

import './styles.scss';

export function ShadowCreationOrImportModalBody({ grid, grids, mode, onGridChange, onModeChange }) {

  const warningText = 'Some formulas, data attributes, and formatting elements may not be preserved in the ' +
    'imported grid';

  return (
    <React.Fragment>
      <label>Chose one to create a grid template</label>
      <Radio
        checked={mode === 'create'}
        name="create"
        onChange={() => onModeChange('create')}
      >
        Create from a grid template, or start fresh with a blank grid
      </Radio>
      {mode === 'create' && (
        <Select
          className="ml-4"
          getOptionLabel={mapName}
          getOptionValue={mapId}
          options={grids}
          value={grid}
          onChange={onGridChange}
        />
      )}
      <Radio
        checked={mode === 'import'}
        name="import"
        onChange={() => onModeChange('import')}
      >
        Create from an uploaded Excel spreadsheet
      </Radio>
      {mode === 'import' && (
        <Alert bsStyle="warning" className="ml-4">
          <div className="shadow-import-warning">
            <FontAwesomeIcon icon={faFlask}/>
            <div className="ml-2">
              <strong>This feature is experimental</strong>
              <p>{warningText}</p>
            </div>
          </div>
        </Alert>
      )}
    </React.Fragment>
  );
}

ShadowCreationOrImportModalBody.propTypes = {
  grid: PropTypes.object,
  grids: PropTypes.array.isRequired,
  mode: PropTypes.string,
  onGridChange: PropTypes.func.isRequired,
  onModeChange: PropTypes.func.isRequired,
};

export default ShadowCreationOrImportModalBody;
